<template>
  <div class="judgeList">
    <new-top :title="title"></new-top>
    <div class="banner" v-if="banner.length > 0">
      <img class="" :src="banner[0].match_image" alt="" />
      <div class="title">
        <h2>{{ banner[0].match_name }}</h2>
        <span>{{ banner[0].match_unit }}</span>
      </div>
    </div>
    <div class="workslist">
      <van-tabs
        v-model="active"
        swipeable
        @change="tabsChange"
        lazy-render
        sticky
      >
        <van-tab v-for="(item, index) in titleList" :title="item" :key="index">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <waterfall-flow-list
                :pictureList="workslist[index].list"
                :radiusFlag="true"
                @toDetail="toDetail"
                @finish="finish"
                :grade="index==1?true:false"
              >
                <template v-slot:text="data">
                  <div class="jj">
                    <span>{{ data.item.signup_theme_name }}</span>
                    <!-- <span class="fenshu" v-if="index == 1"
                      >总评分:{{
                        data.item.grade ? data.item.grade : "未评"
                      }}</span
                    > -->
                  </div>
                </template>
              </waterfall-flow-list>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import newTop from "@/components/travel/newTop.vue";
import waterfallFlowList from "@/components/travel/waterfallFlowList";
import { judgercompetiondetail, judgerresult } from "@/api/travel";
export default {
  name: "JudgeList",
  data() {
    return {
      titleList: ["参赛列表", "评选结果"],
      active: 0,
      uid: "",
      workslist: [
        {
          list: [],
          //列表是否全部加载完成
          moreFlag: false,
          page: 1,
        },
        {
          list: [],
          //列表是否全部加载完成
          moreFlag: false,
          page: 1,
        },
      ],
      banner: [],
      loading: false,
      finished: false,
      refreshing: false,
      title: "作品列表",
    };
  },
  methods: {
    //去详情页
    toDetail(e) {
      if (this.active == 0) {
        this.$router.push({
          name: "JudgeworksDetail",
          params: {
            id: e.id,
            type: this.$route.params.type,
          },
        });
      } else {
        if (e.grade) {
          this.$router.push({
            name: "JudgeworksDetail",
            params: {
              id: e.id,
              type: this.$route.params.type,
            },
          });
        } else {
          this.$toast("评分后可查看!");
        }
      }
    },
    tabsChange(e) {
      // if (!this.workslist[this.active].moreFlag) {
        this.loading = false;
        this.finished = false;
        this.refreshing = false;
      // }
    },
    //加载完成事件
    finish() {
      this.loading = false;
      console.log("渲染完成");
    },
    onLoad() {
      // this.loading = false;
      if (this.active == 0) {
        this.isLoding();
        this.workslist[this.active].page++;
      } else {
        this.isLoding1();
        this.workslist[this.active].page++;
      }
    },
    onRefresh() {
      this.workslist[this.active].page = 1;
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    isLoding() {
      // console.log(this.loading);
      judgercompetiondetail({
        uid: this.uid,
        id: this.$route.params.id,
        match_cate: this.$route.params.type,
        page: this.workslist[this.active].page,
      }).then((res) => {
        if (res.competiondetails.data.length > 0) {
          if (this.refreshing) {
            this.workslist[this.active].list = [];
            this.refreshing = false;
          }
          res.competiondetails.data.forEach((v) => {
            if (this.$route.params.type == 3) {
              this.workslist[this.active].list.push({
                id: v.id,
                albumphotos: v.signup_tripimage,
                signup_theme_name: v.signup_tripname,
              });
            } else {
              this.workslist[this.active].list.push({
                id: v.id,
                albumphotos:
                  this.$route.params.type != 2
                    ? v.signup_image
                    : v.signup_image +
                      "?x-oss-process=video/snapshot,t_0,f_jpg",
                signup_theme_name: v.signup_theme_name,
              });
            }
          });

          res.find_onelists.forEach((v) => {
            this.banner.push(v);
          });
        }
        this.loading = false;
        if (
          res.competiondetails.data.length <= 4 ||
          res.competiondetails.data.length == 0
        ) {
          this.finished = true;
          this.workslist[this.active].moreFlag = true;
        }
      });
    },
    isLoding1() {
      judgerresult({
        uid: this.uid,
        id: this.$route.params.id,
        match_cate: this.$route.params.type,
        page: this.workslist[this.active].page,
      }).then((res) => {
        if (res.competiondetails.data.length > 0) {
          if (this.refreshing) {
            this.workslist[this.active].list = [];
            this.refreshing = false;
          }
          res.competiondetails.data.forEach((v) => {
            if (this.$route.params.type == 3) {
              this.workslist[this.active].list.push({
                id: v.id,
                albumphotos: v.signup_tripimage,
                signup_theme_name: v.signup_tripname,
                grade: v.grade,
              });
            } else {
              this.workslist[this.active].list.push({
                id: v.id,
                albumphotos:
                  this.$route.params.type != 2
                    ? v.signup_image
                    : v.signup_image +
                      "?x-oss-process=video/snapshot,t_0,f_jpg",
                signup_theme_name: v.signup_theme_name,
                grade: v.grade,
              });
            }
          });
         
        }
        this.loading = false;
        if (
          res.competiondetails.data.length <= 4 ||
          res.competiondetails.data.length == 0
        ) {
          this.finished = true;
          this.workslist[this.active].moreFlag = true;
        }
      });
    },
  },
  components: {
    waterfallFlowList,
    newTop,
  },
  created() {
    //设置动态缓存
    this.$store.dispatch("addCacheView", "JudgeList");
    this.uid = sessionStorage.getItem("uid");
  },
};
</script>
<style>
.workslist .van-tabs__content {
  margin-top: 10px;
  /* height: calc(100vh - 280px);
  overflow-y: auto; */
}
</style>
<style scoped>
.judgeList {
  /* background: rgb(48, 43, 43); */
  height: 100vh;
}
.banner {
  width: 100%;
  position: relative;
  padding-top: 44px;
}
.banner img {
  width: 100%;
  height: 190px;
}
.banner .title {
  position: absolute;
  bottom: 26%;
  left: 10%;
  color: #fff;
}
.banner .title h2 {
  font-weight: normal;
  font-size: 20px;
  margin-bottom: 6%;
}
.banner .title span {
  background: rgba(0, 0, 0, 0.4);
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 30px;
}
.workslist {
  background: #fff;
  width: 100%;
  /* height: 600px; */
  position: relative;
  top: -32px;
  border-radius: 20px;
  padding-top: 16px;
}

.jj {
  position: relative;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 8px;
}
.jj span:first-child {
  font-size: 14px;
  display: block;
}
.jj span:last-child {
  font-size: 12px;
}
</style>